// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nco-details .flex h3[data-v-83c9fde6]{color:#8a0ffe}.nco-details .flex a[data-v-83c9fde6]{width:50%;margin:auto;color:#000;background:transparent}@media(min-width:640px){.nco-details .flex a[data-v-83c9fde6]{width:35%}}@media(min-width:1024px){.nco-details .flex a[data-v-83c9fde6]{width:20%}}.careers[data-v-83c9fde6]{padding-top:25px}", ""]);
// Exports
module.exports = exports;
